function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "fopen0",
  d: "M21,3H10V2.92H7c-0.55,0-1,0.45-1,1.01l-3,9.08H2l3-9.08c0-1.12,0.9-2.02,2-2.02h2.99C9.95,0.85,9.08,0,8,0H2 C0.9,0,0,0.89,0,1.99v11.93c0,1.1,0.9,1.99,2,1.99h3h3h10c1.1,0,2-0.89,2-1.99l3-8.94C23,3.89,22.1,3,21,3z"
})));

var SvgFolderOpen = function SvgFolderOpen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "folder_open",
    viewBox: "0 0 23 15.91",
    style: {
      enableBackground: "new 0 0 23 15.91"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFolderOpen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/folder_open.825979d8.svg";
export { ForwardRef as ReactComponent };